<template>
<div class="card border border-gray-200 rounded-lg p-5 bg-white my-5">
  <div class="animate-pulse flex space-x-4">
    <div class="flex-1 space-y-6 py-1">
      <div class="h-2 bg-slate-200 rounded"></div>
      <div class="space-y-3">
        <div class="grid grid-cols-3 gap-4">
          <div class="h-2 bg-slate-200 rounded col-span-2"></div>
          <div class="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>
        <div class="h-2 bg-slate-200 rounded"></div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
export default{

    name:'SkeletonLoading',
    props:{

       
    },
      data() {
    return {
      
    };
  },
    components:{

    },
    async beforeCreate(){
       
        


    }
}


</script>